export class SiteCreateMessage {
  constructor(
    public accountGroupId: string,
    public siteTitle: string,
    public siteTagline: string,
    public defaultDomain: string,
    public templateId?: string,
    public multisite?: boolean,
  ) {}
}
